import React from 'react';
import classnames from 'classnames';

import './WpCardBody.scss';

type Padding = 0 | 16 | 32;
const DEFAULT_PADDING = 16;

export interface Props {
  children?: React.ReactNode;
  padding?: Padding;
  centered?: boolean;
  className?: string;
}

const WpCardBody: React.FC<Props> = ({ children, padding = DEFAULT_PADDING, centered = false, className }: Props) => {
  const classNamePrefix = 'WpCardBody';
  const classes = classnames(
    classNamePrefix,
    className,
    `${classNamePrefix}--p-${padding}`,
    centered ? `${classNamePrefix}--centered` : false
  );
  return <div className={classes}>{children}</div>;
};

export default WpCardBody;
